export default {
      id: "small-star-filled-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "sprite.svg#small-star-filled",
      toString: function () {
        return this.url;
      }
    }